var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid fx_ctr h__fixed scrollable"},[_c('div',{staticClass:"listcon mcol h__fixed spacing scroll__y"},[_c('Postbox'),_c('List',{attrs:{"status":2}})],1),_c('div',{staticClass:"stage mcon h__fixed"},[_c('Pot')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }